import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * module list
 * author xuyuxiong
 * description 合同列表and合同到期预警
 */
import { fetchList, fetchDelete, fetchDetail, fetchChangeChargeStatus, fetchContractExpirationWarningNum, fetchContractExpirationWarning } from '@/api/PMS/customerService/leaseContract/contractList';
import { fetchList as fetchGarageList } from '@/api/PMS/baseInformation/garageoa';
import { fetchList as fetchBuildingList } from '@/api/PMS/baseInformation/building';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { formatJson } from '@/utils/index';
import contractAdd from './add';
import parkingLotContract from './parkingLotContract';
import houseContract from './houseContract';
import houseBill from './houseBill';
import parkingLotBill from './parkingLotBill';
import contractDetail from './contractDetail';
import costDetail from './costDetail';
import returnRent from './returnRent';
import returnRentAgreement from './returnRentAgreement';
import customerDetail from '@/views/PMS/baseInformation/customer/detail';
import importExcel from './import';
import baseBarChart from './baseBarChart'; // 合同到期预警柱状图

import { formatDate } from '@/utils/date';
import waves from '@/directive/waves';
export default {
  components: {
    contractAdd: contractAdd,
    parkingLotContract: parkingLotContract,
    houseContract: houseContract,
    houseBill: houseBill,
    parkingLotBill: parkingLotBill,
    importExcel: importExcel,
    customerDetail: customerDetail,
    contractDetail: contractDetail,
    costDetail: costDetail,
    returnRent: returnRent,
    returnRentAgreement: returnRentAgreement,
    baseBarChart: baseBarChart
  },
  directives: {
    waves: waves
  },
  props: {
    contractType: {
      // 合同类型
      type: Number,
      default: 0
    },
    pageType: {
      type: String,
      default: 'contractList'
    }
  },
  data: function data() {
    return {
      title: '',
      renewalId: '',
      // 续签id
      customerId: '',
      areaGroupId: '',
      currentMonth: '',
      // 当前选择年月
      list: [],
      warnList: [],
      // 合同到期预警列表
      contractData: {},
      // 合同信息
      houseAddData: {},
      baseInfoObj: {},
      // 基本信息
      parkingLotAddData: {},
      parkClauseList: [],
      houseList: [],
      parkingLotList: [],
      dayList: [],
      sumList: [],
      isRenewal: false,
      listLoading: false,
      examine: false,
      isAddContract: false,
      loading: true,
      isRentConfirm: false,
      couldGenerate: false,
      // 能否生成账单
      dialogFormVisible: false,
      dialogHouseContractVisible: false,
      dialogParkingLotContractVisible: false,
      dialogHouseBillVisible: false,
      dialogParkingLotBillVisible: false,
      dialogContractFormVisible: false,
      dialogCostFormVisible: false,
      dialogRentVisible: false,
      dialogRentAgreementVisible: false,
      downloadLoading: false,
      dialogExcelVisible: false,
      dialogCustomerFormVisible: false,
      listQuery: {
        limit: 10,
        page: 1,
        garageId: '',
        buildingId: ''
      },
      warnListQuery: {
        month: this.currentMonth
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      exportQuery: {
        page: 1
      },
      total: 0,
      constractWarnSum: 0,
      contractId: -1,
      dates: [],
      baseData: {},
      clauseList: [],
      standardList: [],
      bondList: [],
      houseClauseList: [],
      houseBondList: [],
      parkLotClauseList: [],
      parkLotStandardList: [],
      cascaderItem: [],
      areaOption: [],
      floorOption: [],
      projectOption: [],
      chargeOption: [],
      options: [],
      garageOption: [],
      buildingOption: [],
      buildingOptions: [],
      parkLotOption: [],
      multipleSelection: []
    };
  },
  computed: {
    currentYearAndMonth: function currentYearAndMonth() {
      var year = new Date(this.currentMonth).getFullYear();
      var month = new Date(this.currentMonth).getMonth() + 1;
      var date = year + '年' + month + '月';
      return date;
    }
  },
  created: function created() {
    this.currentMonth = formatDate(new Date(Date.now()), 'yyyy-MM').toString();
    this.cascaderItem = [];
    this.areaOption = [];
    this.floorOption = [];
    this.buildingOptions = [];

    if (this.pageType === 'contractList') {
      this.getList();
    } else {
      this.getWarnList();
      this.getChartWarnList();
    }

    this.loadGroupOption();
  },
  methods: {
    handleCreate: function handleCreate() {
      this.renewalId = '';
      this.contractId = -1;
      this.title = '新建租赁合同';
      this.isAddContract = true;
      this.isRenewal = false;
      this.dialogFormVisible = true;
      this.baseData = {};
      this.clauseList = [];
      this.parkClauseList = [];
    },
    handleUpdate: function handleUpdate(id, type) {
      // if (type === 1) {
      //   this.dialogHouseBillVisible = true
      // } else {
      //   this.dialogParkingLotBillVisible = true
      // }
      // this.contractId = id
      this.renewalId = '';
      this.isRenewal = false;
      this.getDetail(id, true);
      this.title = '更改租赁合同';
    },
    // 审核
    handleExecutionContract: function handleExecutionContract(index, id, leaseType) {
      var _this = this;

      this.$set(this.list[index], 'showExaminePopover', false);
      fetchChangeChargeStatus({
        id: id,
        leaseType: leaseType,
        contractType: 2
      }).then(function (res) {
        if (res.data.code === 200) {
          _this.getList();

          _this.Alert({
            alertType: 'update',
            message: '审核成功'
          });
        }
      });
    },
    // 销毁
    handleDestructionContract: function handleDestructionContract(index, id, leaseType) {
      var _this2 = this;

      this.$set(this.list[index], 'showDestrutionPopover', false);
      fetchChangeChargeStatus({
        id: id,
        leaseType: leaseType,
        contractType: 6
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.getList();

          _this2.Alert({
            alertType: 'update',
            message: '销毁成功'
          });
        }
      });
    },
    // 终止
    handleTerminationContract: function handleTerminationContract(index, id, leaseType) {
      var _this3 = this;

      this.$set(this.list[index], 'showTerminationPopover', false);
      fetchChangeChargeStatus({
        id: id,
        leaseType: leaseType,
        contractType: 4
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.getList();

          _this3.Alert({
            alertType: 'update',
            message: '终止成功'
          });
        }
      });
    },
    handleTerminationContract2: function handleTerminationContract2(index, id, leaseType) {
      var _this4 = this;

      this.$set(this.warnList[index], 'showTerminationPopover', false);
      fetchChangeChargeStatus({
        id: id,
        leaseType: leaseType,
        contractType: 4
      }).then(function (res) {
        if (res.data.code === 200) {
          _this4.getList();

          _this4.Alert({
            alertType: 'update',
            message: '终止成功'
          });
        }
      });
    },
    handleRenewal: function handleRenewal(id) {
      this.isRenewal = true;
      this.isAddContract = false;
      this.contractId = id;
      this.title = '续签租赁合同';
      this.getDetail(id);
    },
    handleRentAgreement: function handleRentAgreement(id) {
      this.contractId = id;
      this.title = '退租协议-查看详情';
      this.dialogRentAgreementVisible = true;
    },
    handleRentCancellation: function handleRentCancellation(obj) {
      this.contractData = obj;
      this.title = '退租协议-选择退租日期';
      this.dialogRentVisible = true;
    },
    handleDelete: function handleDelete(id) {
      var ids = [];
      ids.push(id);
      this.delete(ids);
    },
    delete: function _delete(ids) {
      var _this5 = this;

      if (ids.length > 0) {
        this.$confirm('你确定是要删除本条合同, 是否继续?', '提示').then(function () {
          fetchDelete(ids).then(function (response) {
            _this5.getList();

            _this5.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleAreaGroupSelect: function handleAreaGroupSelect(id) {
      this.$set(this.listQuery, 'buildingId', '');
      this.$set(this.listQuery, 'garageId', '');
      this.parkLotOption = [];
      this.garageOption = [];
      this.loadGarageOption(id);
      this.loadBuildingOption(id);
    },
    handleWarnAreaGroupSelect: function handleWarnAreaGroupSelect(id) {
      this.$set(this.warnListQuery, 'buildingId', '');
      this.$set(this.warnListQuery, 'garageId', '');
      this.parkLotOption = [];
      this.garageOption = [];
      this.loadGarageOption(id);
      this.loadBuildingOption(id);
    },
    loadBuildingOption: function loadBuildingOption(id) {
      var _this6 = this;

      fetchBuildingList({
        id: id,
        dataType: '0'
      }).then(function (res) {
        _this6.buildingOption = res.data.data;
      });
    },
    // 获取车库
    loadGarageOption: function loadGarageOption(id) {
      var _this7 = this;

      fetchGarageList({
        id: id,
        dataType: '0'
      }).then(function (res) {
        _this7.garageOption = res.data.data;
      });
    },
    // 接收房间合同基本信息
    receiveHouseAddData: function receiveHouseAddData(data) {
      this.houseAddData = data;
      this.baseInfoObj = data.childData;
      this.houseList = data.houseList;
    },
    // 接收车位合同基本信息
    receiveParkingLotAddData: function receiveParkingLotAddData(data) {
      this.parkingLotAddData = data;
      this.parkingLotList = data.parkingLotlist;
    },
    // 接收房间合同条款数据
    receiveHouseContractData: function receiveHouseContractData(data) {
      this.houseClauseList = data.clauseList;
      this.houseBondList = data.bondList;
    },
    // 接收车位合同条款数据
    receiveParkingLotContractData: function receiveParkingLotContractData(data) {
      this.parkLotClauseList = data.clauseList;
      this.parkLotStandardList = data.standardList;
    },
    getcontractDetail: function getcontractDetail(obj) {
      this.title = '账单详情';
      this.contractData = obj;
      this.contractId = obj.id; // this.contractData.buildingName = obj.upName

      this.dialogContractFormVisible = true;
    },
    getCustomerDetail: function getCustomerDetail(customerId, contractId) {
      this.dialogCustomerFormVisible = true;
      this.customerId = customerId;
      this.contractId = contractId;
      this.title = '客户详情';
    },
    handlecostDetail: function handlecostDetail(id) {
      this.title = '费用详情';
      this.contractId = id;
      this.dialogCostFormVisible = true;
    },
    handleWarnFilter: function handleWarnFilter() {
      this.getWarnList();
    },
    // 批量终止
    handleBatchTermination: function handleBatchTermination() {},
    // 合同详情
    getDetail: function getDetail(id, isUpdate) {
      var _this8 = this;

      this.contractId = id;
      this.listLoading = true;
      this.isAddContract = false;
      fetchDetail({
        id: id
      }).then(function (res) {
        _this8.listLoading = false;
        _this8.dialogFormVisible = true;

        if (res.data.code === 200) {
          var childData;
          var data = res.data.data;

          if (!isUpdate) {
            childData = {
              leaseType: data.leaseType,
              areaGroupId: data.areaGroupId,
              customerId: data.customerId,
              contractNo: '',
              contractName: '',
              beginDate: data.endDate,
              endDate: '',
              remark: data.remark,
              fileVos: data.fileVos,
              renewalDate: data.endDate // 续签日期

            };
            _this8.renewalId = data.id;
          } else {
            childData = data;
          }

          childData.contractId = id;
          _this8.baseInfoObj = childData;
          _this8.baseData.childData = childData;
          _this8.baseData.childData.areaGroupId = String(data.areaGroupId);
          _this8.baseData.houseList = data.leaseContractResourceVos;
          _this8.baseData.parkingLotlist = data.leaseContractResourceVos;

          if (data.leaseType === 1) {
            _this8.clauseList = data.leaseContractTeamsVos.filter(function (item) {
              return item.contractTeamsType === 1;
            });
            _this8.bondList = data.leaseContractTeamsVos.filter(function (item) {
              return item.contractTeamsType === 2;
            });

            _this8.clauseList.forEach(function (item, index) {
              _this8.$set(_this8.clauseList[index], 'chargeStandardId', item.leaseContractStandardVos[0].chargeStandardId);

              item.chargeMath = item.leaseContractStandardVos[0].chargeMath;
              item.chargePrice = item.leaseContractStandardVos[0].chargePrice;
            });

            _this8.bondList.forEach(function (item, index) {
              _this8.$set(_this8.clauseList[index], 'chargeStandardId', item.leaseContractStandardVos[0].chargeStandardId);

              item.chargeMath = item.leaseContractStandardVos[0].chargeMath;
              item.chargePrice = item.leaseContractStandardVos[0].chargePrice;
            });
          } else {
            _this8.parkClauseList = data.leaseContractTeamsVos;

            if (data.leaseContractTeamsVos && data.leaseContractTeamsVos.length > 0) {
              _this8.standardList = data.leaseContractTeamsVos[0].leaseContractStandardVos;
            }
          }
        }
      });
    },
    handleUpload: function handleUpload() {
      this.title = '导入Excel';
      this.dialogExcelVisible = true;
    },
    handleExport: function handleExport() {
      var _this9 = this;

      var exportList = [];
      fetchList(this.exportQuery).then(function (res) {
        exportList = res.data.data;

        _this9.$confirm('你确定要导出合同记录吗, 是否继续?', '提示').then(function () {
          if (exportList !== null && exportList.length > 0) {
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require('@/vendor/Export2Excel'));
            }).then(function (excel) {
              var tHeader = ['合同编号', '合同名称', '合同类型', '小区名称', '楼宇/停车场', '租户', '合同状态', '合同开始日期', '合同结束日期', '退租日期', '续签合同', '备注', '租赁面积(m²)', '费用合计(元)'];
              var fileterVal = ['contractNo', 'contractName', 'leaseTypeName', 'areaGroupName', 'buildingName', 'customerName', 'contractTypeName', 'beginDate', 'endDate', 'refundTime', 'upContractName', 'remark', 'totalHouseArea', 'amount'];
              var data = formatJson(fileterVal, exportList);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: '合同记录',
                autoWidth: true,
                bookType: 'xlsx'
              });
            });
          } else {
            _this9.Alert({
              alertType: 'error',
              message: '暂无数据，无法导出！'
            });
          }
        });
      });
    },
    loadGroupOption: function loadGroupOption() {
      var _this10 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (res) {
        if (res.data.data) {
          _this10.options = res.data.data.map(function (item) {
            return {
              dicName: item.name,
              dicValue: item.id
            };
          });
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList: function getList() {
      var _this11 = this;

      this.loading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      if (this.contractType > 0) {
        this.listQuery.contractType = this.contractType;
      } else {
        this.listQuery.contractType = '';
      }

      fetchList(this.listQuery).then(function (res) {
        _this11.loading = false;
        _this11.list = res.data.data;
        _this11.total = res.data.total;
      });
    },
    getWarnList: function getWarnList() {
      var _this12 = this;

      this.warnListQuery.month = this.currentMonth;
      fetchContractExpirationWarning(this.warnListQuery).then(function (res) {
        _this12.warnList = res.data.data;
      });
    },
    getChartWarnList: function getChartWarnList() {
      var _this13 = this;

      fetchContractExpirationWarningNum({
        month: this.currentMonth
      }).then(function (res) {
        _this13.dayList = res.data.data.dayList;
        _this13.sumList = res.data.data.sumList;
        _this13.constractWarnSum = res.data.data.sum;
      });
    },
    handleMonthChange: function handleMonthChange(val) {
      if (val) {
        this.getChartWarnList();
        this.getWarnList();
      } else {
        this.warnList = [];
        this.dayList = [];
        this.sumList = [];
        this.constractWarnSum = [];
        this.$message({
          message: '月份不能为空',
          type: 'warning'
        });
      }
    },
    handleProjectChange: function handleProjectChange(value) {
      this.$set(this.listQuery, 'standardId', '');
      var item = this.projectOption.find(function (ele) {
        return ele.chargeItemId === value;
      });

      if (item) {
        this.loadChargeOption(item.chargeName);
      }
    },
    loadChargeOption: function loadChargeOption() {},
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
      this.exportQuery = JSON.parse(JSON.stringify(this.listQuery));
      delete this.exportQuery.limit;
    },
    handCancle: function handCancle(state) {
      var _this14 = this;

      this.$emit('updateTabList'); // 更新tab栏数值

      this.dialogFormVisible = false;
      this.dialogHouseContractVisible = false;
      this.dialogParkingLotContractVisible = false;
      this.dialogHouseBillVisible = false;
      this.dialogParkingLotBillVisible = false;
      this.dialogCustomerFormVisible = false;
      this.dialogRentVisible = false;
      this.dialogExcelVisible = false;
      this.dialogRentAgreementVisible = false;
      this.dialogContractFormVisible = false;

      switch (state) {
        case 'parkingLotAdd':
          if (this.contractId > 0 && this.isRenewal) {
            this.title = '续签租赁合同';
          } else if (this.contractId > 0) {
            this.title = '更改租赁合同';
          } else {
            this.title = '新建租赁合同';
          }

          setTimeout(function () {
            _this14.dialogParkingLotContractVisible = true;
          }, 300);
          break;

        case 'houseAdd':
          if (this.contractId > 0 && this.isRenewal) {
            this.title = '续签租赁合同';
          } else if (this.contractId > 0) {
            this.title = '更改租赁合同';
          } else {
            this.title = '新建租赁合同';
          }

          setTimeout(function () {
            _this14.dialogHouseContractVisible = true;
          }, 300);
          break;

        case 'parkingLotBill':
          this.dialogParkingLotBillVisible = false;
          break;

        case 'parkingLotContractBack':
          this.dialogParkingLotContractVisible = false;
          this.isAddContract = false;
          setTimeout(function () {
            _this14.dialogFormVisible = true;
          }, 300);
          break;

        case 'parkingLotContractNext':
          this.dialogParkingLotContractVisible = false;
          this.couldGenerate = true;
          setTimeout(function () {
            _this14.dialogParkingLotBillVisible = true;
          }, 300);
          break;

        case 'houseContractGenerate':
          this.dialogHouseContractVisible = false;
          this.couldGenerate = true;
          setTimeout(function () {
            _this14.dialogHouseBillVisible = true;
          }, 300);
          break;

        case 'renewal':
          this.isAddContract = false;
          this.title = '续签租赁合同';
          this.getDetail(this.contractId);
          break;

        case 'rentCancellation':
          this.title = '退租协议-选择退租日期';
          this.dialogRentVisible = true;
          break;

        case 'change':
          this.renewalId = '';
          this.getDetail(this.contractId, true);
          this.title = '更改租赁合同';
          break;

        case 'rentAgreement':
          this.isRentConfirm = false;
          this.dialogRentAgreementVisible = true;
          this.title = '退租协议-查看详情';
          break;

        case 'returnRent':
          this.dialogRentVisible = true;
          this.title = '退租协议-选择退租日期';
      }

      this.getList();
    }
  }
};